import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChatSession } from '../../../domain/chat/models/ChatSession';
import { ChatSessionsState, initialChatSessionsState } from './chatSessionsState';

const chatSessionsSlice = createSlice({
    name: 'chatSessions',
    initialState: initialChatSessionsState,
    reducers: {
        setSessions: (state: ChatSessionsState, action: PayloadAction<ChatSession[]>) => {
            state.byId = {};
            state.allIds = [];

            for (const session of action.payload) {
                state.byId[session.id] = session;
                state.allIds.push(session.id);
            }
        },
        upsertSession: (state: ChatSessionsState, action: PayloadAction<ChatSession>) => {
            const session = action.payload;
            const exists = Boolean(state.byId[session.id]);

            state.byId[session.id] = session;

            if (!exists) {
                state.allIds.unshift(session.id);
            }
        },
        updateSessionTitle: (
            state: ChatSessionsState,
            action: PayloadAction<{ sessionId: string; title: string; isTitleGenerated?: boolean }>,
        ) => {
            const { sessionId, title, isTitleGenerated } = action.payload;
            const session = state.byId[sessionId];
            if (!session) return;
            session.title = title;
            if (isTitleGenerated !== undefined) {
                session.isTitleGenerated = isTitleGenerated;
            }
        },
        removeSession: (state: ChatSessionsState, action: PayloadAction<string>) => {
            const sessionId = action.payload;

            delete state.byId[sessionId];
            state.allIds = state.allIds.filter((id) => id !== sessionId);
        },
        removeSessions: (state: ChatSessionsState, action: PayloadAction<string[]>) => {
            const ids = new Set(action.payload);

            for (const id of ids) {
                delete state.byId[id];
            }

            state.allIds = state.allIds.filter((id) => !ids.has(id));
        },
        clearSessions: (state: ChatSessionsState) => {
            state.byId = {};
            state.allIds = [];
        },
    },
});

export const { setSessions, upsertSession, updateSessionTitle, removeSession, removeSessions, clearSessions } = chatSessionsSlice.actions;

export default chatSessionsSlice.reducer;
